import AppointmentsAndPreAdvicesBaseController from './appointments_and_pre_advices_base_controller';

export default class extends AppointmentsAndPreAdvicesBaseController {
  get entityIdKey() {
    return 'preAdviceId';
  }

  fetchUrl(id) {
    return `/pre_advices/${id}/gate_in.json`;
  }
}
